import { defineStore } from 'pinia'
import { services, getHeader, getUserInfo } from '@/assets/js/config.js'
import { useProductStore } from '@/stores/productStore'
import axios from 'axios'

export const useCommissionStore = defineStore('commissionStore', {
	state: () => ({
		hubManagerUserList: [],
		teamList: [],
		teamGroupList: [],
	}),
	getters: {

	},
	actions: {
		async generateCommission(commission_content) {
			if (_gHlp.isEmpty(commission_content)) {
				return false;
			}
			return await axios.post(services.commission + 'sale', commission_content, { headers: getHeader() })
				.then(res => {
					const sales = res.data;
					useProductStore().updateProduct(commission_content.prod_id, { prod_commission_at: sales.created_at });
					_gNotif.notifySuccess('<b>Commission</b> - Successfully Generated.')
				})
				.catch(e => {
					_gNotif.errorFunction(e)
				})

		},
		async getCommissionHubManagerUserList() {
			try {
				const res = await axios.get(services.commission + 'team-group/list/hub-manager', { headers: getHeader() })
				this.hubManagerUserList = res.data.data
			} catch (e) {
				this.hubManagerUserList = []
				console.log('Get user hub manager list failed:' + e.response.data.message)
			}
		},
		async getCommissionTeamManagerUserList() {
			try {
				const res = await axios.get(services.commission + 'team/list/team-manager', { headers: getHeader() })
				this.teamManagerUserList = res.data.data
			} catch (e) {
				this.teamManagerUserList = []
				console.log('Get user team manager list failed:' + e.response.data.message)
			}
		},
		async getCommissionTeamList() {
			try {
				const params = _gHlp.generateQueryParams({
					search:{
						corporate_id: _gAuth.activeCorporateId()
					},
					paginate:'no_paginate'
				})
				const res = await axios.get(services.commission + 'team?'+params, { headers: getHeader() })
				this.teamList = res.data.data
			} catch (e) {
				this.teamList = []
				console.log('Get user team manager list failed:' + e.response.data.message)
			}
		},
		async getCommissionTeamGroupList() {
			try {
				const params = _gHlp.generateQueryParams({
					search:{
						corporate_id: _gAuth.activeCorporateId()
					},
					paginate:'no_paginate'
				})
				const res = await axios.get(services.commission + 'team-group?'+params, { headers: getHeader() })
				this.teamGroupList = res.data.data
			} catch (e) {
				this.teamGroupList = []
				console.log('Get user team manager list failed:' + e.response.data.message)
			}
		},
		async getApprovalList(filter) {
			try {
				const params = _gHlp.generateQueryParams({
					search:filter,
					paginate:'no_paginate'
				})
				const res = await axios.get(services.commission + 'approval?'+params, { headers: getHeader() })
				return res.data.data;
			} catch (e) {
				console.log('req approval failed:' + e.response.data.message)
				return false
			}
		},
		async createApproval(data) {
			try {
				console.log(data);
				const res = await axios.post(services.commission + 'approval',data, { headers: getHeader() })
				return res.data.data;
			} catch (e) {
				console.log('req approval failed:' + e.response.data.message)
				return false
			}
		},
		async createTeamGroup(data) {
			try {
				const res = await axios.post(services.commission + 'team-group',data, { headers: getHeader() })
				return res.data.data
			} catch (e) {
				console.log('Create hub team group failed:' + e.response.data.message)
				return false
			}
		},
		async updateTeamGroup(id, data) {
			try {
				const res = await axios.put(services.commission + 'team-group/'+id, data, { headers: getHeader() })
				return res.data.data
			} catch (e) {
				console.log('Create hub team group failed:' + e.response.data.message)
				return false
			}
		},
		async createTeam(data) {
			try {
				const res = await axios.post(services.commission + 'team',data, { headers: getHeader() })
				return res.data.data
			} catch (e) {
				console.log('Create hub team failed:' + e.response.data.message)
				return false
			}
		},
		async updateTeam(id, data) {
			try {
				const res = await axios.put(services.commission + 'team/'+id, data, { headers: getHeader() })
				return res.data.data
			} catch (e) {
				console.log('Create hub team failed:' + e.response.data.message)
				return false
			}
		},
		async createTeamMember(data) {
			try {
				const res = await axios.post(services.commission + 'team-member',data, { headers: getHeader() })
				return res.data.data
			} catch (e) {
				console.log('Create hub team member failed:' + e.response.data.message)
				return false
			}
		},
		async updateTeamMember(id, data) {
			try {
				const res = await axios.put(services.commission + 'team-member/'+id, data, { headers: getHeader() })
				return res.data.data
			} catch (e) {
				console.log('Create hub team member failed:' + e.response.data.message)
				return false
			}
		},
		async updateUserExtend(user_id, data) {
			try {
				const res = await axios.put(services.commission + 'commission-setting/user-extend/'+user_id, data, { headers: getHeader() })
				return res.data.data
			} catch (e) {
				console.log('Create hub team member failed:' + e.response.data.message)
				return false
			}
		},
		async getHubTeamMembers(app_code, corporate_id, user_id, role_id) {
			try {
				const params = new URLSearchParams({
					application_code: app_code,
					corporate_id: corporate_id,
					user_id: user_id,
					role_id: role_id
				});

				const res = await axios.get(
					services.commission + 'hub_team_members?' + params.toString(),
					{ headers: getHeader() }
				);

				return res.data.data || [];
			} catch (e) {
				return [];
			}
		},
	}
})